import { styled } from '@mui/material';
import { FilterInputWrapper } from 'components/inputs/FilterInputWrapper';

export const CampusItemWrapper = styled('div')({
    display: 'grid',
    gap: '5px',
});

export const IconWrapper = styled('div')({
    minWidth: 'auto',
    marginRight: 20,
    width: 18,
});

export const Icon = styled('div')({
    width: 18,
});

export const MenuItem = styled('div')({
    padding: '11px 20px',
});

export const Paper = styled('div')({
    maxHeight: 300,
    maxWidth: 300,
});

export const RootTextWrapper = styled('div')({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: 150,
});

export const CampusNameWrapper = styled('div')({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'initial',
    display: '-webkit-box',
    wordBreak: 'break-word',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
});

export const CampusAddressWrapper = styled('div')({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});

export const FilterHeader = styled(FilterInputWrapper)({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
});
